module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"revpash":"RevPash"},"es":{"revpash":"RevPash"}}')
  delete Component.options._Ctor
}
